<!-- Landing Page Container -->
<ion-content class="ion-padding" [class.landing-mobile-bg]="isMobile">
  <ion-grid class="landing-container">
    
    <!-- Hero Section -->
    <ion-row>
      <ion-col>
        <ion-text color="primary">
          <h1 class="ion-text-center main-title">Receiving Manager</h1>
        </ion-text>
      </ion-col>
    </ion-row>

    <!-- Login Prompt -->
    <ion-row *ngIf="!userIsLoggedIn">
      <ion-col>
        <ion-card class="login-card">
          <ion-card-content class="ion-text-center">
            <ion-icon name="person-circle-outline" color="primary" class="icon-badge"></ion-icon>
            <p class="login-text">
              Please <span class="login-link" (click)="login()">log in</span> to access receiving logs and submit new entries.
            </p>

            <!-- Install prompt. Hidden once the app is running from its own icon
                 (PwaService), so an installed user is not told to install it.
                 Sits on the logged-out card on purpose: installing does not need
                 a session, and this is the screen a first-time user lands on. -->
            <ion-button
              *ngIf="canInstallApp"
              class="install-prompt-btn"
              fill="clear"
              size="small"
              (click)="showInstallHelp = true">
              <ion-icon name="download-outline" slot="start"></ion-icon>
              Add to your home screen
            </ion-button>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>

    <!-- User does not have access message -->
    <ion-row *ngIf="userIsLoggedIn && !userHasAccess">
      <ion-col>
        <ion-card class="warning-card">
          <ion-card-content class="ion-text-center">
            <ion-icon name="warning-outline" color="warning" class="icon-badge"></ion-icon>
            <p class="warning-text">You do not currently have access to this application.</p>
            <p class="warning-subtext">Please contact your administrator to request access.</p>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>
    
    <!-- Main Content (desktop): Visible when user is logged in and has access -->
    <ion-row *ngIf="userIsLoggedIn && userHasAccess && !isMobile">
      <ion-col>
        
        <!-- Receiving Section -->
        <ion-list class="section">
          <ion-list-header class="section-header">
            <ion-icon name="cube-outline" color="secondary" slot="start"></ion-icon>
            <ion-label>
              <h2 class="section-title">Receiving</h2>
                        

            </ion-label>
          </ion-list-header>
          
          <ion-grid>
            <ion-row>
              <ion-col size="12" size-md="6">
                <ion-card button (click)="onSubmitReceivingEntry()" class="action-card">
                  <ion-card-content>
                    <ion-icon name="create-outline" class="card-icon-wrapper primary"></ion-icon>
                    <ion-label class="card-text">
                      <h3>Submit New Entry</h3>
                      <p class="card-description">Create a new receiving log</p>
                    </ion-label>
                    <ion-icon name="chevron-forward-outline" class="arrow-icon"></ion-icon>
                  </ion-card-content>
                </ion-card>
              </ion-col>
              
              <ion-col size="12" size-md="6">
                <ion-card button (click)="navigateTo('/receiving/view-logs')" class="action-card">
                  <ion-card-content>
                    <ion-icon name="folder-open-outline" class="card-icon-wrapper secondary"></ion-icon>
                    <ion-label class="card-text">
                      <h3>View Logs</h3>
                      <p class="card-description">Browse receiving logs</p>
                    </ion-label>
                    <ion-icon name="chevron-forward-outline" class="arrow-icon"></ion-icon>
                  </ion-card-content>
                </ion-card>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-list>

  

        <!-- SOF Receiving Section -->
        <ion-list class="section">
          <ion-list-header class="section-header">
            <ion-icon name="clipboard-outline" color="secondary" slot="start"></ion-icon>
            <ion-label>
              <h2 class="section-title">SOF Receiving</h2>
            </ion-label>
          </ion-list-header>

          <ion-grid>
            <ion-row>
              <ion-col size="12" size-md="6">
                <ion-card button (click)="navigateTo('/sof-receiving')" class="action-card">
                  <ion-card-content>
                    <ion-icon name="clipboard-outline" class="card-icon-wrapper primary"></ion-icon>
                    <ion-label class="card-text">
                      <h3>Pick &amp; Stage Orders</h3>
                      <p class="card-description">Work the SOF queue for your location</p>
                    </ion-label>
                    <ion-icon name="chevron-forward-outline" class="arrow-icon"></ion-icon>
                  </ion-card-content>
                </ion-card>
              </ion-col>

              <ion-col size="12" size-md="6">
                <ion-card button (click)="navigateTo('/sof-receiving/history')" class="action-card">
                  <ion-card-content>
                    <ion-icon name="folder-open-outline" class="card-icon-wrapper secondary"></ion-icon>
                    <ion-label class="card-text">
                      <h3>SOF History</h3>
                      <p class="card-description">Browse completed SOF orders</p>
                    </ion-label>
                    <ion-icon name="chevron-forward-outline" class="arrow-icon"></ion-icon>
                  </ion-card-content>
                </ion-card>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-list>

              <!-- Laydown Space Section -->
        <ion-list class="section">
          <ion-list-header class="section-header">
            <ion-icon name="grid-outline" color="secondary" slot="start"></ion-icon>
            <ion-label>
              <h2 class="section-title">Laydown Space</h2>
            </ion-label>
          </ion-list-header>
          
          <ion-grid>
            <ion-row>
              <ion-col size="12" size-md="6">
                <ion-card button (click)="navigateTo('/laydown/new-log')" class="action-card">
                  <ion-card-content>
                    <ion-icon name="create-outline" class="card-icon-wrapper primary"></ion-icon>
                    <ion-label class="card-text">
                      <h3>Submit New Entry</h3>
                      <p class="card-description">Create a new laydown-space log</p>
                    </ion-label>
                    <ion-icon name="chevron-forward-outline" class="arrow-icon"></ion-icon>
                  </ion-card-content>
                </ion-card>
              </ion-col>
              
              <ion-col size="12" size-md="6">
                <ion-card button (click)="navigateTo('/laydown/view-logs')" class="action-card">
                  <ion-card-content>
                    <ion-icon name="folder-open-outline" class="card-icon-wrapper secondary"></ion-icon>
                    <ion-label class="card-text">
                      <h3>View Logs</h3>
                      <p class="card-description">Browse laydown-space logs</p>
                    </ion-label>
                    <ion-icon name="chevron-forward-outline" class="arrow-icon"></ion-icon>
                  </ion-card-content>
                </ion-card>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-list>

        <!-- Testing Section (dev / UAT only) -->
        <ion-list class="section" *ngIf="showTestingTools">
          <ion-list-header class="section-header">
            <ion-icon name="build-outline" color="tertiary" slot="start"></ion-icon>
            <ion-label>
              <h2 class="section-title">Testing</h2>
            </ion-label>
          </ion-list-header>
          
          <ion-grid>
            <ion-row>
              <ion-col size="12" size-md="6">
                <ion-card button (click)="openCameraTest()" class="action-card">
                  <ion-card-content>
                    <ion-icon name="camera-outline" class="card-icon-wrapper tertiary"></ion-icon>
                    <ion-label class="card-text">
                      <h3>Camera Testing</h3>
                      <p class="card-description">Test camera and QR code scanning</p>
                    </ion-label>
                    <ion-icon name="chevron-forward-outline" class="arrow-icon"></ion-icon>
                  </ion-card-content>
                </ion-card>
              </ion-col>

              <ion-col size="12" size-md="6">
                <ion-card button (click)="openPrinterTest()" class="action-card">
                  <ion-card-content>
                    <ion-icon name="print-outline" class="card-icon-wrapper tertiary"></ion-icon>
                    <ion-label class="card-text">
                      <h3>Printer Testing</h3>
                      <p class="card-description">Send test jobs to the print API</p>
                    </ion-label>
                    <ion-icon name="chevron-forward-outline" class="arrow-icon"></ion-icon>
                  </ion-card-content>
                </ion-card>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-list>

      </ion-col>
    </ion-row>

    <!-- Main Content (mobile): modern stacked section cards -->
    <ion-row *ngIf="userIsLoggedIn && userHasAccess && isMobile">
      <ion-col>
        <div class="mobile-landing">

  

          <!-- Receiving -->
          <div class="mobile-section-card">
            <div class="mobile-section-head">
              <span class="mobile-section-chip primary">
                <ion-icon name="cube-outline"></ion-icon>
              </span>
              <span class="mobile-section-name">Receiving</span>
            </div>
            <div class="mobile-action-row">
              <ion-button expand="block" class="mobile-action mobile-action-primary" (click)="onSubmitReceivingEntry()">
                <ion-icon slot="start" name="add-outline"></ion-icon>
                New entry
              </ion-button>
              <ion-button expand="block" fill="outline" color="medium" class="mobile-action mobile-action-secondary" (click)="navigateTo('/receiving/view-logs')">
                <ion-icon slot="start" name="folder-open-outline"></ion-icon>
                View logs
              </ion-button>
            </div>
          </div>

          <!-- SOF Receiving -->
          <div class="mobile-section-card">
            <div class="mobile-section-head">
              <span class="mobile-section-chip">
                <ion-icon name="clipboard-outline"></ion-icon>
              </span>
              <span class="mobile-section-name">SOF Receiving</span>
            </div>
            <div class="mobile-action-row">
              <ion-button expand="block" class="mobile-action mobile-action-primary" (click)="navigateTo('/sof-receiving')">
                <ion-icon slot="start" name="cube-outline"></ion-icon>
                Pick &amp; stage
              </ion-button>
              <ion-button expand="block" fill="outline" color="medium" class="mobile-action mobile-action-secondary" (click)="navigateTo('/sof-receiving/history')">
                <ion-icon slot="start" name="time-outline"></ion-icon>
                History
              </ion-button>
            </div>
          </div>

          <!-- Laydown Space -->
          <div class="mobile-section-card">
            <div class="mobile-section-head">
              <span class="mobile-section-chip">
                <ion-icon name="grid-outline"></ion-icon>
              </span>
              <span class="mobile-section-name">Laydown Space</span>
            </div>
            <div class="mobile-action-row">
              <ion-button expand="block" class="mobile-action mobile-action-primary" (click)="navigateTo('/laydown/new-log')">
                <ion-icon slot="start" name="add-outline"></ion-icon>
                New entry
              </ion-button>
              <ion-button expand="block" fill="outline" color="medium" class="mobile-action mobile-action-secondary" (click)="navigateTo('/laydown/view-logs')">
                <ion-icon slot="start" name="folder-open-outline"></ion-icon>
                View logs
              </ion-button>
            </div>
          </div>

          <!-- Testing (dev / UAT only) -->
          <div class="mobile-testing" *ngIf="showTestingTools">
            <div class="mobile-testing-head">
              <ion-icon name="build-outline"></ion-icon>
              <span class="mobile-testing-name">Testing</span>
              <ion-badge color="warning" class="mobile-testing-badge">dev / UAT only</ion-badge>
            </div>
            <div class="mobile-action-row">
              <ion-button expand="block" fill="outline" color="medium" class="mobile-action" (click)="openCameraTest()">
                <ion-icon slot="start" name="camera-outline"></ion-icon>
                Camera test
              </ion-button>
              <ion-button expand="block" fill="outline" color="medium" class="mobile-action" (click)="openPrinterTest()">
                <ion-icon slot="start" name="print-outline"></ion-icon>
                Printer test
              </ion-button>
            </div>
          </div>

        </div>
      </ion-col>
    </ion-row>

  </ion-grid>

  <!-- The same install instructions the public /install-help route serves, in a
       modal for people already inside the app. Both render the one shared
       app-pwa-instructions content component. -->
  <app-pwa-instructions-modal
    [isOpen]="showInstallHelp"
    (closeModal)="showInstallHelp = false">
  </app-pwa-instructions-modal>

</ion-content>